<template lang="pug">
    v-layout(align-start)
        v-flex
            v-card.pa-2(width='100vw' outlined color='grey_1')
              v-app-bar(dark color='primary')
                v-toolbar-title.headline PROPIEDADES DEL SISTEMA
              v-card-text
                v-row(dense)
                  v-col(cols='12')
                    v-card(color='white')
                      v-card-subtitle.title(style='color: black') GENERALES
                      v-card-text
                        div.tabla
                            div.header
                                div.descripcion
                                    span DESCRIPCION
                                div.valor
                                    span VALOR
                                div.accion
                                    span ACCIÓN
                            div.item(v-for="(item) in configuracion")
                                div(v-for="(atr, i) in item" :key="i")
                                    div.cuerpo(v-if="atr.descripcion")
                                        div.descripcion
                                            span(style='padding-left:5px;') {{atr.descripcion}}
                                        div.valor
                                            span(style='padding-left:5px;' v-show="!atr.valor") NO
                                            span(style='padding-left:5px;' v-show="atr.valor") SI
                                            //- span(style='padding-left:5px;') {{atr.valor}}
                                        div.accion
                                            a(@click='editItem(atr,i,false)')
                                              v-icon(dark) edit
                                //-   a(@click='view(item)')
                                //-     v-icon(dark='') remove_red_eye
                                //-   a(@click='modalcrear(item)')
                                //-     v-icon(dark='') add_circle_outline
                  v-col(cols='12')
                    v-card(color='white')
                      v-card-subtitle.title(style='color: black') COMPRAS
                      v-card-text
                        div.tabla
                          div.header
                              div.descripcion
                                  span DESCRIPCION
                              div.valor
                                  span VALOR
                              div.accion
                                  span ACCIÓN
                          div.item(v-for="(item) in compras")
                              div(v-for="(atr, i) in item" :key="i")
                                  div.cuerpo(v-if="atr.descripcion")
                                      div.descripcion
                                          span(style='padding-left:5px;') {{atr.descripcion}}
                                      div.valor
                                          span(style='padding-left:5px;' v-show="!atr.valor") NO
                                          span(style='padding-left:5px;' v-show="atr.valor") SI
                                      div.accion
                                          a(@click='editItem(atr,i,true,"compras")')
                                            v-icon(dark) edit
                  v-col(cols='12')
                    v-card(color='white')
                      v-card-subtitle.title(style='color: black') CLIENTES
                      v-card-text
                        div.tabla
                          div.header
                              div.descripcion
                                  span DESCRIPCION
                              div.valor
                                  span VALOR
                              div.accion
                                  span ACCIÓN
                          div.item(v-for="(item) in clientes")
                              div(v-for="(atr, i) in item" :key="i")
                                  div.cuerpo(v-if="atr.descripcion")
                                      div.descripcion
                                          span(style='padding-left:5px;') {{atr.descripcion}}
                                      div.valor
                                          span(style='padding-left:5px;' v-show="!atr.valor") NO
                                          span(style='padding-left:5px;' v-show="atr.valor") SI
                                      div.accion
                                          a(@click='editItem(atr,i,true,"clientes")')
                                            v-icon(dark) edit
                  v-col(cols='12')
                    v-card(color='white')
                      v-card-subtitle.title(style='color: black') PROVEEDORES
                      v-card-text
                        div.tabla
                          div.header
                              div.descripcion
                                  span DESCRIPCION
                              div.valor
                                  span VALOR
                              div.accion
                                  span ACCIÓN
                          div.item(v-for="(item) in proveedores")
                              div(v-for="(atr, i) in item" :key="i")
                                  div.cuerpo(v-if="atr.descripcion")
                                      div.descripcion
                                          span(style='padding-left:5px;') {{atr.descripcion}}
                                      div.valor
                                          span(style='padding-left:5px;' v-show="!atr.valor") NO
                                          span(style='padding-left:5px;' v-show="atr.valor") SI
                                      div.accion
                                          a(@click='editItem(atr,i,true,"proveedores")')
                                            v-icon(dark) edit
                  v-col(cols='12')
                    v-card(color='white')
                      v-card-subtitle.title(style='color: black') EMPLEADOS
                      v-card-text
                        div.tabla
                          div.header
                              div.descripcion
                                  span DESCRIPCION
                              div.valor
                                  span VALOR
                              div.accion
                                  span ACCIÓN
                          div.item(v-for="(item) in empleados")
                              div(v-for="(atr, i) in item" :key="i")
                                  div.cuerpo(v-if="atr.descripcion")
                                      div.descripcion
                                          span(style='padding-left:5px;') {{atr.descripcion}}
                                      div.valor
                                          span(style='padding-left:5px;' v-show="!atr.valor") NO
                                          span(style='padding-left:5px;' v-show="atr.valor") SI
                                      div.accion
                                          a(@click='editItem(atr,i,true,"empleados")')
                                            v-icon(dark) edit
                  v-col(cols='12')
                    v-card(color='white')
                      v-card-subtitle.title(style='color: black') PRODUCTOS
                      v-card-text
                        div.tabla
                          div.header
                              div.descripcion
                                  span DESCRIPCION
                              div.valor
                                  span VALOR
                              div.accion
                                  span ACCIÓN
                          div.item(v-for="(item) in productos")
                              div(v-for="(atr, i) in item" :key="i")
                                  div.cuerpo(v-if="atr.descripcion")
                                      div.descripcion
                                          span(style='padding-left:5px;') {{atr.descripcion}}
                                      div.valor
                                          span(style='padding-left:5px;' v-show="!atr.valor") NO
                                          span(style='padding-left:5px;' v-show="atr.valor") SI
                                      div.accion
                                          a(@click='editItem(atr,i,true,"productos")')
                                            v-icon(dark) edit
                  v-col(cols='12')
                    v-card(color='white')
                      v-card-subtitle.title(style='color: black') TASA DE CAMBIO
                      v-card-text
                        div.tabla
                          div.header
                              div.descripcion
                                  span DESCRIPCION
                              div.valor
                                  span VALOR
                              div.accion
                                  span ACCIÓN
                          div.item(v-for="(item) in tasa")
                              div(v-for="(atr, i) in item" :key="i")
                                  div.cuerpo(v-if="atr.descripcion")
                                      div.descripcion
                                          span(style='padding-left:5px;') {{atr.descripcion}}
                                      div.valor
                                          span(style='padding-left:5px;') {{ atr.valor}}
                                      div.accion
                                          a(@click='numerico(atr,i)')
                                            v-icon(dark) edit
            v-dialog(v-model='dialog', persistent max-width='70%')
                v-card
                  v-app-bar(dark color='primary')
                    span.headline {{ this.editedItem.descripcion }}
                  v-divider
                  v-card-text(style='padding: 0px 0px 0px 0px')
                    v-container
                      v-col(cols='12' sm='12' md='12' v-if="nume")
                        v-text-field(v-model.number='editedItem.valor' @click='limpiar()' dense outlined)
                      v-col(cols='12' sm='12' md='12' v-else)
                        v-select(v-model='valor' dense outlined @change="valorSeleccionado" :items="valores" label='Seleccione una Opción')
                  v-card-actions
                      v-spacer
                      v-btn(color='error', small dark @click='close')
                        v-icon mdi-close
                        | Cancelar
                      v-btn(color='success', small dark @click='save(editedItem.valor, index, bool, id)')
                        v-icon mdi-content-save
                        | Guardar
</template>

<script>
import Api from '@/services/methods'
import { EventBus } from '../Events'
import { formatoDecimal } from '@/helpers/index'
export default {
  data: () => ({
    nume: false,
    snack: false,
    snackColor: '',
    snackText: '',
    dialog: false,
    configuracion: [],
    compras: [],
    clientes: [],
    proveedores: [],
    empleados: [],
    productos: [],
    tasa: [],
    bool: null,
    id: null,
    index: '',
    search: '',
    permisosRuta: {},
    dialog2: false,
    editedIndex: -1,
    valor: '',
    valores: ['SI', 'NO'],
    editedItem: {
      descripcion: '',
      valor: null,
      estatus: '',
      indice: ''
    },
    defaultItem: {
      nombre: ''
    }
  }),
  computed: {
  },
  watch: {
    dialog (val) {
      val || this.close()
    },
    dialog2 (val) {
      val || this.close()
    }
  },
  created () {
    EventBus.$on('actualizacionTasaPropiedades', data => {
      this.initialize()
    })
    this.initialize()
  },
  methods: {
    limpiar () {
      this.editedItem.valor = 0
    },

    valorSeleccionado (data) {
      if (data === 'SI') {
        this.editedItem.valor = true
      } else {
        this.editedItem.valor = false
      }
    },
    initialize () {
      this.config()
      /* this.permisosRuta = this.$store.state.empresa[0].permisos.find(permiso => permiso.ruta == 'cuentas') */
    },
    validarCrear () {
      /* return this.permisosRuta.accion.includes('Crear') */
      return true
    },
    validarModificar () {
      /* return this.permisosRuta.accion.includes('Modificar') */
      return true
    },
    validarEliminar () {
      /* return this.permisosRuta.accion.includes('Eliminar') */
      return true
    },
    config () {
      Api.get('configuracion')
        .then(response => {
          this.configuracion = []
          this.configuracion.push(response.data)
          this.compras = []
          this.compras.push(response.data.compras)
          this.clientes = []
          this.clientes.push(response.data.clientes)
          this.proveedores = []
          this.proveedores.push(response.data.proveedores)
          this.empleados = []
          this.empleados.push(response.data.empleados)
          this.productos = []
          this.productos.push(response.data.productos)
          this.tasa = []
          this.tasa.push(response.data.tasa)
          this.tasa[0].tasaDia.valor = parseFloat(this.tasa[0].tasaDia.valor)
          //this.tasa[0].tasaDia.valor = formatoDecimal(this.tasa[0].tasaDia.valor)
        })
        .catch(error => {
          if (error.response) {
            this.$swal({
              icon: 'error',
              title: 'Error al cargar',
              //text: 'Por favor, verifique los datos e intente de nuevo'
            })
          } else if (error.request) {
            this.$swal({
              icon: 'error',
              title: 'Error de red',
              text: 'Por favor verique su conexion de internet'
            })
          } else {
            console.log('Error', error.message);
          }
        })
    },
    view (item) {
      this.editedItem = Object.assign({}, item)
      this.dialog3 = true
    },
    editItem (item, key, val, obj) {
      if (item.valor === false) {
        this.valor = 'NO'
      } else if (item.valor === true) {
        this.valor = 'SI'
      } else {
        this.valor = item.valor
      }
      this.bool = val
      this.id = obj
      this.index = key
      this.editedItem = Object.assign({}, item)
      this.dialog = true
    },
    numerico (atr, i) {
      this.nume = true
      this.editItem(atr, i, true, 'tasa')
    },
    close () {
      this.dialog = false
      this.nume = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
        this.valor = ''
      }, 300)
    },
    permissDenied (status) {
      if (status === '403') {
        this.$swal({
          icon: 'error',
          title: 'Permiso denegado',
          text: 'No tiene pemisos suficientes para ver esta página',
          allowOutsideClick: false,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'ok',
          onAfterClose: () => {
            window.location.href = '/home'
          }
        })
      }
    },
    save (valor, key, bool, i) {
      this.$swal({
        title: 'Cargando...',
        html: 'Esperando respuesta del servidor',
        allowOutsideClick: false,
        onBeforeOpen: () => {
          this.$swal.showLoading()
        }
      })
      if (bool === false) {
        // Guarda bien para la configuracion general
        this.configuracion[0][key].valor = valor
      } else {
        // Aqui no esta guardando
        this.configuracion[0][i][key].valor = valor
      }
      Api.put('configuracion', this.configuracion[0])
        .then(response => {
          console.log(response)
          this.$swal({
            icon: 'success',
            title: 'Modificacion exitosa',
            text: 'Todos los cambios han sido efectuados'
          })
          this.$store.dispatch('config', this.configuracion[0])
          EventBus.$emit('actualizacionTasaMenu', '0')
          this.config()
          this.close()
        })
        .catch(error => {
          if (error.response) {
            this.$swal({
              icon: 'error',
              title: 'Error al modificar',
              text: 'Por favor, verifique los datos e intente de nuevo'
            })
          } else if (error.request) {
            this.$swal({
              icon: 'error',
              title: 'Error de red',
              text: 'Por favor verique su conexion de internet'
            })
          } else {
            console.log('Error', error.message);
          }
        })
    }
  }
}
</script>
<style lang='scss'>
@import '~@/assets/scss/config.scss';
</style>
